import { TransferOrderListPage } from '@/features/transfer-order/pages/TransferOrderListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/transfer-order/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderListPage,
})
